class FreeShipping extends HTMLElement {
  constructor() {
    super();
    this.handleCartUpdated = this.handleCartUpdated.bind(this);
  }

  connectedCallback() {
    this.warningsInner = this.querySelector(".drawer-promotions__inner");
    this.message = this.getAttribute("data-message");
    this.messageSuccess = this.getAttribute("data-message-success");
    this.currency = this.getAttribute("data-currency") || "BRL";
    this.country = this.getAttribute("data-country") || "BR";
    this.rawMinValue = parseFloat(this.getAttribute("data-min-value"));
    this.minValue = this.getParsedMinValue();

    document.addEventListener("cart:update", this.handleCartUpdated);
    document.addEventListener("discount:update", this.handleCartUpdated);

    if (!this.warningsInner || this.warningsInner.children.length === 0) {
      this.renderPromotion(0);
    }
    this.runPromotions();
  }

  disconnectedCallback() {
    document.removeEventListener("cart:update", this.handleCartUpdated);
    document.removeEventListener("discount:update", this.handleCartUpdated);
  }

  getParsedMinValue() {
    const value = Number.isFinite(this.rawMinValue) ? this.rawMinValue : 0;
    return this.currency === "BRL" ? value / 100 : value;
  }

  handleCartUpdated(event) {
    const base =
      event &&
      event.detail &&
      typeof event.detail.freeShippingBase === "number"
        ? event.detail.freeShippingBase
        : null;

    if (base !== null) {
      this.renderPromotion(base);
      return;
    }

    this.runPromotions();
  }

  formatMoney(value) {
    return value.toLocaleString(this.country === "BR" ? "pt-BR" : "en", {
      style: "currency",
      currency: this.currency,
      minimumFractionDigits: this.currency === "BRL" ? 2 : 0,
    });
  }

  renderPromotion(currentValue) {
    if (!this.warningsInner) return;

    const reached = currentValue >= this.minValue;
    const missingValue = Math.max(0, this.minValue - currentValue);
    const percentage =
      this.minValue > 0 ? Math.min(100, (currentValue / this.minValue) * 100) : 100;

    const text = reached
      ? this.messageSuccess.replace("[min]", this.formatMoney(this.minValue))
      : this.message
          .replace("[min]", this.formatMoney(this.minValue))
          .replace("[missing_value]", this.formatMoney(missingValue));

    const item = document.createElement("div");
    item.classList.add("drawer-promotions__item");
    item.innerHTML = `
      <div class="drawer-promotions__text">${text}</div>
      <div class="drawer-promotions__progress-bar" style="--percentage: ${percentage}%"></div>
    `;

    this.warningsInner.innerHTML = "";
    this.warningsInner.append(item);
    this.classList.add("show");
  }

  runPromotions() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const fallbackValue = (cart.items_subtotal_price || 0) / 100;
        this.renderPromotion(fallbackValue);
      })
      .catch((error) => {
        console.error("Erro ao atualizar barra de frete grátis:", error);
      });
  }
}

if (!customElements.get("free-shipping")) {
  customElements.define("free-shipping", FreeShipping);
}
